import { useLocation } from "react-router-dom";

/**
 * Build 96.20 — kort intro-rad direkt efter menyn på startsidan.
 * Rendas endast på "/" så andra sidor lämnas orörda.
 * Ingen Backend-anrop, ingen state, ingen navigation.
 */
export default function HomeIntroLine() {
  const { pathname } = useLocation();
  if (pathname !== "/") return null;
  return (
    <section
      data-testid="home-intro"
      translate="no"
      className="notranslate bg-parchment border-b border-warm-border/60"
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-4 sm:py-6 text-bark/85 font-body text-[14px] sm:text-[15px] leading-relaxed">
        <p>
          Du behövs här. Det här bygger vi tillsammans – ett levande digitalt minne med kärlek till bygden, gemenskap och framtidstro. Dela det du ser, minns eller vet: en bild, en plats, ett tips, ett evenemang eller ett anslag. Var med.
        </p>
      </div>
    </section>
  );
}
